<template>
	<div class="box">
		<div class="logo">
			<img src="../assets/images/login-logo.png" alt="" />
		</div>
		<div class="form">
			<a-form
				:model="formState"
				name="basic"
				autocomplete="off"
				class="login-form"
			>
				<div class="input-box">
					<input
						type="text"
						v-model="formState.phone"
						class="phone"
						required=""
						autocomplete="on"
						@input="numberChange"
						@keydown.enter="enterClick"
					/>
					<label>手机号</label>
					<span class="suffix" @click="clearPhone">
						<img
							src="@/assets/images/clear-icon.png"
							v-if="formState.phone"
							alt=""
						/>
					</span>
				</div>
				<div class="input-box">
					<input
						:type="seePass ? 'text' : 'password'"
						v-model="formState.password"
						class="password"
						required=""
						autocomplete="on"
						@input="handleInput"
						@keydown.enter="enterClick"
					/>
					<label>密码</label>
					<span
						v-if="formState.password"
						class="suffix"
						@click="triggerEye"
					>
						<img
							src="@/assets/images/eye@2x.png"
							v-if="!seePass"
							alt=""
						/>
						<img
							src="@/assets/images/eyeclose@2x.png"
							alt=""
							v-if="seePass"
						/>
					</span>
				</div>
				<a-form-item>
					<a-button type="primary" class="login-btn" @click="login"
						>登录</a-button
					>
				</a-form-item>
			</a-form>
		</div>

		<div class="footer" @click="goConcat">申请试用</div>
	</div>
</template>

<script setup>
	import { reactive, ref, watch, onMounted, onBeforeUnmount } from "vue";
	import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons-vue";
	import { useRouter } from "vue-router";
	import { message } from "ant-design-vue";
	// 引入接口
	import { useLogin } from "../api/users";
	// 引入vuex
	import { useStore } from "vuex";
	const store = useStore();

	const router = useRouter();

	// 表单数据
	const formState = reactive({
		phone: "",
		password: ""
	});

	// 颜色
	const fillColor = ref("rgba(0, 0, 0, 0)");
	const first = ref(true);

	// 定时器
	const timer = ref(null);

	// 密码是否可见
	const seePass = ref(false);

	// 监听颜色变化
	watch(
		() => fillColor.value,
		(newValue, oldValue) => {
			if (newValue) {
				const form = document.querySelector(".login-form");
				if (first.value) {
					form.classList.add("autofill");
				}
				first.value = false;
				clearInterval(timer);
			}
		}
	);

	const handleInput = () => {
		const form = document.querySelector(".login-form");
		form.classList.remove("autofill");
	};

	const login = () => {
		if (formState.phone == "") {
			message.warning("请输入手机号！");
		} else if (formState.password == "") {
			message.warning("请输入密码！");
		} else {
			useLogin(formState)
				.then(res => {
					// 将数据存储与Vuex中
					store.commit("upDateUserInfo", res);
					message.success("登录成功");
					router.push("/project");
				})
				.catch(err => {
					console.log(err);
					// message.success("登录成功");
				});
		}
	};

	// 处理手机号输入的数据
	const numberChange = e => {
		handleInput();
		formState.phone = formState.phone.replace(/\D/g, "");
		if (formState.phone.length > 11) {
			formState.phone = formState.phone.slice(0, 11);
		}
	};

	// 密码可见或者不可见
	const triggerEye = () => {
		seePass.value = !seePass.value;
	};

	// 清空手机号
	const clearPhone = () => {
		formState.phone = "";
	};

	// 回车键触发
	const enterClick = () => {
		login();
	};

	const goConcat = () => {
		router.push("/concat");
	};

	onMounted(() => {
		timer.value = setInterval(() => {
			fillColor.value = getComputedStyle(
				document.querySelector(".phone"),
				":-internal-autofill-selected"
			).backgroundColor;
		}, 600);
	});
	onBeforeUnmount(() => {
		clearInterval(timer.value);
		timer.value = null;
	});
</script>

<style lang="less" scoped>
	.box {
		.form {
			margin-top: 38px;

			.input-box {
				position: relative;
				border-bottom: 1px solid rgba(0, 0, 0, 0.16);
				margin-bottom: 54px;

				input {
					width: 100%;
					padding: 6px 0;
					font-size: 16px;
					border: none;
					border-bottom: 1px solid rgba(255, 255, 255, 0.16);
					outline: none;
					background: transparent;
				}
				label {
					position: absolute;
					top: 0;
					left: 0;
					padding: 6px 0;
					font-size: 18px;
					pointer-events: none;
					transition: all 0.3s;
					opacity: 0.65;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					font-size: 14px;
					color: #000000;
					letter-spacing: 0;
					line-height: 22px;
				}

				input:focus ~ label,
				input:valid ~ label {
					top: -26px;
					left: 0;
					font-size: 14px;
				}

				.suffix {
					position: absolute;
					top: 45%;
					right: 0px;
					z-index: 2;
					display: flex;
					align-items: center;
					line-height: 0;
					transform: translateY(-50%);

					img {
						width: 24px;
						height: 24px;
						cursor: pointer;
					}

					.anticon {
						cursor: pointer;
						color: #00000073;
						transition: all 0.3s;
						display: none;
					}
				}

				input:focus ~ .suffix .anticon,
				input:valid ~ .suffix .anticon {
					display: block;
				}
			}

			.login-form.autofill {
				label {
					top: -26px;
					left: 0;
					font-size: 14px;
					transition: all 0.1s;
				}
			}

			.login-btn {
				width: 100%;
				height: 44px;
				border-radius: 4px;

				font-family: PingFangSC-Medium;
				font-weight: 500;
				font-size: 18px;
				color: #ffffff;
				letter-spacing: 0;
				text-align: center;
				line-height: 24px;
			}
		}
	}
</style>
